import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hamburger",
  "use": "hamburger-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"hamburger\"><path fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" d=\"M25.833 13.437L10 13.34m19 7.105l-19-.114m14.25 6.322L10 26.568\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol